<template>
	<div class="chinaEuropeTrain">

		<Header :typeHeader="'defaultHeader'">
			<!-- banner -->
			<img slot="headerImage" :src="imgList.bannerImg" alt="">
			<!-- 标题 -->
			<div slot="headerTitle">{{$store.state.navShow == true ?'国际海运':'Shipping'}}</div>
			<div style="font-size: 1.125rem; color: #FFFFFF; font-weight: 100; margin-top: 0.6rem;" slot="headerTitle">
				{{$store.state.navShow == true ?'海运＋多联运输派送模式':'Shipping + Multimodal Transportation Delivery Mode'}}</div>
		</Header>

		<div class="TopTitle" data-aos="fade-up">
			<div class="">
				<!-- {{this.$route.name}} -->
				{{$store.state.navShow == true ? $route.name : $route.meta.EnName}}
			</div>
		</div>
		<div class="ContentText" data-aos="fade-down">
			<p>{{$store.state.navShow == true ?'MG集团拥有十余年的海运服务经验，专业成熟的操作团队可提供安全、高效的定制化海案。路线：由中国各大港口通过海运到达汉堡/阿姆斯特丹/ 鹿特丹/ 圣彼得堡等城市，并提供专业的清关服务。' : 'MG group has more than ten years of experience in marine service, and its professional and mature operation team can provide safe and efficient customized sea cases. Route: arrive at Hamburg / AMSTERDAM / Rotterdam / St. Petersburg and other cities by sea from major ports in China, and provide professional customs clearance services.'}}</p>
		</div>

		<div class="ContentIntroduceList">
			<div class="ContentIntroduce" v-for="(item,index) in $store.state.navShow == true ?oceanShippingList :oceanShippingListE" :key="index">
				<img class="ContentIntroduceImg" :src="item.img">
				<div class="ContentIntroduceText">
					<div class="ContentIntroduceText_L">
						<img class="ContentIntroduceText_L_Img" :src="item.icon"
							:style="'width:' + item.iconW+'px'+';' + 'height:' + item.iconH+'px;' ">
						<!-- width: 23px; height: 22.5px; -->
						<div class="ContentIntroduceText_L_Text">
							{{ item.title }}
						</div>
					</div>
					<div class="ContentIntroduceText_R">
						<div class="ContentIntroduceText_R_Text_01" v-for="(text, index1) in item.list" :key="index1">
							{{ text.text }}
						</div>
					</div>
				</div>
			</div>
		</div>


		<div class="buttonImgOS">
			<!-- <img :src="imgList.bottonImg"> -->
			<img src="../../../assets/chinaAndRussia/CR_oceanShippingbotton.png">
		</div>
	</div>
</template>

<script>
	import Header from "@/components/header.vue";
	export default {
		components: {
			Header,
		},
		data() {
			return {
				www: 23,
				imgList: {
					bannerImg: require('@/assets/chinaAndRussia/CR_oceanShippingbanner.jpg'),
					// backgroundImg: require('@/assets/chinaAndRussia/backgroundImg.png'),
					aircraft: require('@/assets/chinaAndRussia/aircraft.png'),
					bottonImg: require('@/assets/chinaAndRussia/CR_oceanShippingbotton.png'),
				},
				oceanShippingList: [{
						id: 1,
						icon: require('@/assets/chinaAndRussia/oceanShippingListIcon_1.png'),
						iconW: '29',
						iconH: '28.5',
						img: require('@/assets/chinaAndRussia/oceanShippingListImg_1.jpg'),
						title: '整柜海运服务',
						list: [{
								text: '船舶可用空间管理'
							},
							{
								text: '经济效益最大化运转方案'
							},
							{
								text: '灵活的弹性行程安排'
							},
							// text_1: '船舶可用空间管理',
							// text_2: '经济效益最大化运转方案',
							// text_3: '灵活的弹性行程安排',
						]
					},
					{
						id: 2,
						icon: require('@/assets/chinaAndRussia/oceanShippingListIcon_2.png'),
						iconW: '27',
						iconH: '27',
						img: require('@/assets/chinaAndRussia/oceanShippingListImg_2.jpg'),
						title: '多联派送服务',
						list: [{
								text: '货物送达港口后的专属清关团队'
							},
							{
								text: '多式联运解决方案制定'
							},
							{
								text: '限时到达及门到门运输服务'
							},
						]
						// text_1: '货物送达港口后的专属清关团队',
						// text_2: '多式联运解决方案制定',
						// text_3: '限时到达及门到门运输服务',
					},
					{
						id: 3,
						icon: require('@/assets/chinaAndRussia/oceanShippingListIcon_3.png'),
						iconW: '26',
						iconH: '28.5',
						img: require('@/assets/chinaAndRussia/oceanShippingListImg_3.jpg'),
						title: '运输方案定制服务',
						list: [{
								text: '海陆空铁高效配合完美运输方案'
							},
							{
								text: '整合全球所有关键线路及港口情况信息'
							},
							{
								text: '成本与时效相结合的定制服务'
							},
						]
						// text_1: '海陆空铁高效配合完美运输方案',
						// text_2: '整合全球所有关键线路及港口情况信息',
						// text_3: '成本与时效相结合的定制服务',
					},
					{
						id: 4,
						icon: require('@/assets/chinaAndRussia/oceanShippingListIcon_4.png'),
						iconW: '29',
						iconH: '26',
						img: require('@/assets/chinaAndRussia/oceanShippingListImg_4.jpg'),
						title: '境外商务对接咨询服务',
						list: [{
								text: '境外法务咨询'
							},
							{
								text: '境外财务咨询'
							},
							{
								text: '境外仓储服务'
							},
						]
						// text_1: '境外法务咨询',
						// text_2: '境外财务咨询',
						// text_3: '境外仓储服务',
					},
				],
				oceanShippingListE: [{
						id: 1,
						icon: require('@/assets/chinaAndRussia/oceanShippingListIcon_1.png'),
						iconW: '29',
						iconH: '28.5',
						img: require('@/assets/chinaAndRussia/oceanShippingListImg_1.jpg'),
						title: 'FCL shipping service',
						list: [{
								text: 'Ship space management'
							},
							{
								text: 'Operation plan for maximizing economic benefits'
							},
							{
								text: 'Flexible and flexible itinerary'
							},
							// text_1: '船舶可用空间管理',
							// text_2: '经济效益最大化运转方案',
							// text_3: '灵活的弹性行程安排',
						]
					},
					{
						id: 2,
						icon: require('@/assets/chinaAndRussia/oceanShippingListIcon_2.png'),
						iconW: '27',
						iconH: '27',
						img: require('@/assets/chinaAndRussia/oceanShippingListImg_2.jpg'),
						title: 'Multiple delivery service',
						list: [{
								text: 'Exclusive customs clearance team after the goods arrive at the port'
							},
							{
								text: 'Multimodal transport solution development'
							},
							{
								text: 'Time-limited arrival and door-to-door shipping services'
							},
						]
						// text_1: '货物送达港口后的专属清关团队',
						// text_2: '多式联运解决方案制定',
						// text_3: '限时到达及门到门运输服务',
					},
					{
						id: 3,
						icon: require('@/assets/chinaAndRussia/oceanShippingListIcon_3.png'),
						iconW: '26',
						iconH: '28.5',
						img: require('@/assets/chinaAndRussia/oceanShippingListImg_3.jpg'),
						title: 'Customized service of project transportation plan',
						list: [{
								text: 'Efficient coordination of sea, land, air and rail with a perfect transportation solution'
							},
							{
								text: 'Integrate information on all key routes and port conditions around the world'
							},
							{
								text: 'Customized service combining cost and timeliness'
							},
						]
						// text_1: '海陆空铁高效配合完美运输方案',
						// text_2: '整合全球所有关键线路及港口情况信息',
						// text_3: '成本与时效相结合的定制服务',
					},
					{
						id: 4,
						icon: require('@/assets/chinaAndRussia/oceanShippingListIcon_4.png'),
						iconW: '29',
						iconH: '26',
						img: require('@/assets/chinaAndRussia/oceanShippingListImg_4.jpg'),
						title: 'Overseas business docking consulting services',
						list: [{
								text: 'Overseas legal consultation'
							},
							{
								text: 'Overseas Financial Consulting'
							},
							{
								text: 'Overseas warehousing service'
							},
						]
						// text_1: '境外法务咨询',
						// text_2: '境外财务咨询',
						// text_3: '境外仓储服务',
					},
				]

			}
		},
		methods: {


		}
	}
</script>

<style lang="less">
	.TopTitle {
		width: 92%;
		height: 4.95rem;
		position: relative;
		margin: 0 4%;
		top: -3.2rem;
		border-bottom: 1px solid rgba(204, 204, 204, .5);

		&>div {
			position: absolute;
			top: 1.25rem;
			font-size: 1rem;
			font-family: Microsoft YaHei;
			font-weight: bold;
			color: #FFFFFF;
			padding: 1.2rem 3.375rem 1.2rem 0.75rem;
			background: #2e67b1 linear-gradient(270deg, rgba(3, 0, 0, .15), hsla(0, 0%, 100%, .15));
		}
	}

	.ContentText {
		width: 92%;
		margin: 0 4%;
		// background-color: #000066;
		margin-top: -1.575rem;
		text-align: left;

		&>p {
			font-size: 0.875rem;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #666666;
			text-indent: 2em;
			margin-bottom: 1.25rem;
			text-align: justify;
		}
	}

	.ContentIntroduceList {
		width: 92%;
		margin: 0 4%;

		.ContentIntroduce:last-child {
			margin-bottom: 0;
		}

		.ContentIntroduce {
			width: 100%;
			margin-bottom: 0.625rem;
			background-color: rgba(45, 106, 171, 1);

			.ContentIntroduceImg {
				width: 100%;
				height: 11.875rem;
			}

			.ContentIntroduceText {
				background-color: rgba(45, 106, 171, 1);
				display: flex;
				padding: 1.25rem .7rem;
				justify-content: space-between;
				align-items: center;

				.ContentIntroduceText_L {
					text-align: left;
					min-width: 6.525rem;

					.ContentIntroduceText_L_Img {
						margin-bottom: 0.575rem;
					}

					.ContentIntroduceText_L_Text {
						// white-space:nowrap;
						font-size: .9025rem;
						font-family: Microsoft YaHei;
						font-weight: bold;
						color: #FFFFFF;
					}
				}

				.ContentIntroduceText_R {
					text-align: right;

					.ContentIntroduceText_R_Text_01 {
						font-size: 0.7rem;
						font-family: Microsoft YaHei;
						font-weight: 400;
						color: #FFFFFF;
						line-height: 1.65rem;
					}
				}
			}

		}

	}



	.tableTitleTitle {
		// margin: 1.875rem 0 0.625rem 0;
		font-size: 0.75rem;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #2E67B1;
		text-align: left;
		margin-bottom: 1.1875rem;
	}


	.buttonImgOS {
		width: 100%;
		height: 5.9375rem;
		min-height: 5.9375rem;
		z-index: -1;
	}
</style>
